module.exports = __webpack_public_path__ + "static/elemental_gem_air-e36308bc2a38a3f3e6886423f6925f90.jpg";